"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSegments = function (time) {
    var segments = time.split(':');
    if (segments.length !== 3) {
        throw new Error('diffTimeOnly expected time in hh:mm:ss format');
    }
    return segments;
};
var parseExpectingNumber = function (tt, minimum, maximumNotIncluding) {
    var parsed = parseInt(tt, 10);
    if (isNaN(parsed)) {
        throw new Error('Expected number, got ' + tt);
    }
    if (parsed < minimum) {
        throw new Error('Expected minimum of ' + minimum + ', got ' + parsed);
    }
    if (parsed >= maximumNotIncluding) {
        throw new Error('Expected max (not including) ' + minimum + ', got ' + parsed);
    }
    return parsed;
};
var secondsIntoDay = function (time) {
    var _a = getSegments(time), h = _a[0], m = _a[1], s = _a[2];
    var seconds = parseExpectingNumber(s, 0, 60);
    var minutesInSeconds = parseExpectingNumber(m, 0, 60) * 60;
    var hoursInSeconds = parseExpectingNumber(h, 0, 24) * 60 * 60;
    return seconds + minutesInSeconds + hoursInSeconds;
};
var timeUtils = {
    // difference between t1 and the next t2
    elapsedBetweenTimes: function (t1, t2, unit) {
        if (unit === void 0) { unit = 'seconds'; }
        var secondsIntoDay1 = secondsIntoDay(t1);
        var secondsIntoDay2 = secondsIntoDay(t2);
        var differenceInSeconds = secondsIntoDay2 - secondsIntoDay1;
        switch (unit) {
            case 'seconds':
                return differenceInSeconds;
            case 'minutes':
                return differenceInSeconds / 60;
            case 'hours':
                return differenceInSeconds / (60 * 60);
            default:
                throw new Error('unexpected unit ' + unit);
        }
    },
};
exports.default = timeUtils;
//# sourceMappingURL=timeUtils.js.map